import { isPresent } from "@estaly/ui";

export function formatDate(date, locale) {
  let formattedDate = null;
  if (isPresent(date)) {
    formattedDate = new Date(date).toLocaleString(locale);
  }
  return formattedDate;
}
